import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { Slider, SliderSlide } from "@ui"

import { ArticlePreview } from "../molecules"
import { ArticlePreviewClipPath } from "../atoms"

const MIN_RECOMMENDATIONS_LENGTH = 4

export const RecommendationsCarousel = observer(
  function RecommendationsCarousel() {
    const {
      BlogModel: { recommendedPosts },
      AnalyticsModel,
      GlobalModel,
    } = useStore()

    if (
      !recommendedPosts.length ||
      recommendedPosts.length < MIN_RECOMMENDATIONS_LENGTH
    ) {
      return null
    }

    return (
      <section
        className="pt-10 pb-8 w-full bg-gray-50 tablet:pt-15 tablet:pb-12.5 desktop:pt-20"
        data-test-id="recommendations"
      >
        <div className="container px-0 space-y-6 w-full laptop:px-20 desktop:px-22 desktop:space-y-8">
          <h4 className="font-serif text-2xl tablet:text-4xl uppercase tracking-2 px-4 tablet-m:px-6 laptop:text-center">
            {GlobalModel.getTemplate("recommended.title")}
          </h4>
          <Slider
            options={{
              spaceBetween: -24,
              slidesPerView: "auto",
              loop: true,
              navigation: true,
              centeredSlides: true,
              breakpoints: {
                768: {
                  spaceBetween: 0,
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 0,
                },
              },
            }}
          >
            {recommendedPosts.map((article) => (
              <SliderSlide
                key={article.id}
                className="w-full px-4 tablet:w-1/2 desktop:w-1/3 desktop:px-2"
                onClick={() => AnalyticsModel.sendRecommendedArticleEvents()}
              >
                <ArticlePreview
                  article={article}
                  classes={{
                    container: "desktop:h-[697px]",
                  }}
                />
              </SliderSlide>
            ))}
          </Slider>
        </div>
        <ArticlePreviewClipPath />
      </section>
    )
  },
)
